import { IPropertyInfoMetadata } from "../../../DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";

export interface IEntityBaseProperties
{
    id: IPropertyInfoMetadata;
    rowVersion: IPropertyInfoMetadata;
    createdByUserId: IPropertyInfoMetadata;
    createdDate: IPropertyInfoMetadata;
    createdWhileElevated: IPropertyInfoMetadata;
    lastUpdatedByUserId: IPropertyInfoMetadata;
    lastUpdatedDate: IPropertyInfoMetadata;
    lastUpdatedWhileElevated: IPropertyInfoMetadata;

    createdByUser: IPropertyInfoMetadata;
    lastUpdatedByUser: IPropertyInfoMetadata;
}

export const EntityBaseProperties: IEntityBaseProperties = {

    id: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                description: "Unique Reference"
            },
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Unique Reference"
            },
            {
                evaluator: {
                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                },
                $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.EntityBase+IdMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
            }
        ],
        name: "Id",
        propertyTypeId: "System.Guid, System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    rowVersion: {
        attributes: [],
        name: "RowVersion",
        propertyTypeId: "System.Byte[], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    createdByUserId: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Created By User"
            },
            {
                evaluator: {
                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                },
                $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.EntityBase+CreatedByUserIdMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
            }
        ],
        name: "CreatedByUserId",
        propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    createdDate: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Created Date"
            },
            {
                evaluator: {
                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                },
                $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.EntityBase+CreatedDateMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
            }
        ],
        name: "CreatedDate",
        propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    createdWhileElevated: {
        attributes: [],
        name: "CreatedWhileElevated",
        propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    lastUpdatedByUserId: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Last Updated By User"
            },
            {
                evaluator: {
                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                },
                $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.EntityBase+LastUpdatedByUserIdMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
            }
        ],
        name: "LastUpdatedByUserId",
        propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    lastUpdatedDate: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Last Updated Date"
            },
            {
                evaluator: {
                    $type: "SeriouslyRAD.Framework.Data.Evaluation.Evaluators.TrueEvaluator, SeriouslyRAD.Framework.Data.Entities"
                },
                $type: "SeriouslyRAD.Framework.ClientAwareMandatoryEvaluatorAttribute`1[[SeriouslyRAD.Framework.Data.EntityBase+LastUpdatedDateMandatoryEvaluatorAttributeType, SeriouslyRAD.Framework.Data.Entities]], SeriouslyRAD.Framework.Data.Entities"
            }
        ],
        name: "LastUpdatedDate",
        propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    lastUpdatedWhileElevated: {
        attributes: [],
        name: "LastUpdatedWhileElevated",
        propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },

    createdByUser: {
        "attributes": [],
        "name": "CreatedByUser",
        "propertyTypeId": "SeriouslyRAD.Framework.Data.Entities.User, SeriouslyRAD.Framework.Data.Entities",
        "$type": "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    lastUpdatedByUser: {
        "attributes": [],
        "name": "LastUpdatedByUser",
        "propertyTypeId": "SeriouslyRAD.Framework.Data.Entities.User, SeriouslyRAD.Framework.Data.Entities",
        "$type": "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },

};